var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-tag",class:(_vm.state === 1) ? 'active' : 'inactive'},[_c('span',{staticClass:"cicle",class:(_vm.state === 1) ? 'circle-active' : 'circle-inactive'}),_c('h1',[_vm._v(_vm._s(_vm.data))])])}
var staticRenderFns = []

export { render, staticRenderFns }